// extracted by mini-css-extract-plugin
export default {"wrapper":"Footer_wrapper__jEnVR","social-list":"Footer_social-list__HatoZ"};